import { useNavigate } from 'react-router-dom'

import { Box, Button, IconBadge, Link, Text, Title } from '@factorialco/deprecated-design-system'
import { MyTrainingsSessionFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { formatSessionDate } from 'modules/trainings/lib/utils'

type Props = {
  session: MyTrainingsSessionFragment
}

export const NextSessionRow = ({ session }: Props) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const sessionDate = formatSessionDate({
    startsAt: session?.startsAt,
    endsAt: session.endsAt,
    duration: session.duration,
    schedule: session.schedule,
  })

  if (!session || session?.training?.status == 'draft') return null

  return (
    <Box gap="s16">
      <Title
        title={i18n.t('trainings.my_trainings_revamp.overview.next_session_title')}
        variant="500"
      />
      <Box
        paddingY="s12"
        paddingX="s24"
        flexDirection="row"
        justifyContent="spaceBetween"
        border={{
          all: {
            color: 'grey400',
            style: 'solid',
            width: 's1',
          },
        }}
        borderRadius={{ all: 'abs008' }}
        alignItems="center"
      >
        <Box flexDirection="row" gap="s8" alignItems="center">
          <IconBadge icon="calendar" color="viridian200" iconColor="viridian1200" />

          <Text size="300" ellipsis color="grey1000">
            {session.name}
          </Text>
        </Box>
        <Box>
          <Text size="300" color="grey1000">
            {sessionDate}
          </Text>
        </Box>
        {session.link && (
          <Box>
            <Link.Href href={session.link} external target="_blank">
              <Text size="300" weight="medium" underlined color="textLink">
                {'Link'}
              </Text>
            </Link.Href>
          </Box>
        )}
        <Box>
          <Text size="300" ellipsis color="grey1000">
            {session.location}
          </Text>
        </Box>
        <Button
          type="secondary"
          iconName="arrow-right"
          onClick={() =>
            navigate(
              navigation.myTrainings.revamp.overview.sidepanel.fullPath({
                sessionId: session.id,
                trainingId: Number(session.training?.id),
              })
            )
          }
        />
      </Box>
    </Box>
  )
}
